import { toast } from 'react-toastify'
import type { ToastContent, ToastPosition, TypeOptions } from 'react-toastify'

export const showToastMessage = (props: ToastProps): ToastContent => {
  props.hideProgressBar = true
  return toast.info(props.message, props)
}

export const showErrorMessage = (props: ToastProps): ToastContent => {
  props.hideProgressBar = true
  return toast.error(props.message, props)
}

export type ToastProps = {
  message: string
  position?: ToastPosition
  autoClose?: number
  hideProgressBar?: boolean
  closeOnClick?: boolean
  pauseOnHover?: boolean
  draggable?: boolean
  type?: TypeOptions
}
